import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const joinWaitlist = (data) =>
  axios.post(`${API}/waitlist`, data).then((r) => r.data);

export const getWaitlistCount = () =>
  axios.get(`${API}/waitlist/count`).then((r) => r.data);
